import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {PullRequestState} from '../../../../types'
import type {ViewerRole} from '../deciders/use-decide-next-action'
import {DeleteHeadBranch, shouldShowDeleteHeadBranch} from './DeleteHeadBranch'
import {RestoreHeadBranch} from './RestoreHeadBranch'
import {ReopenPullRequest} from './ReopenPullRequest'
import {useMergeabilityData} from '../mergeability/use-mergeability-data'
import {GitPullRequestClosedIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {useLayoutQuery} from '../../../../page-data/loaders/use-layout-query'

export function shouldShowClosedPR(pullRequestState: PullRequestState) {
  return pullRequestState === PullRequestState.Closed
}

export function ClosedPR({userRole}: {userRole?: ViewerRole}) {
  const pullRequestState = usePullRequestState()
  const {user} = useLayoutQuery().data
  const mergeabilityData = useMergeabilityData()

  if (!shouldShowClosedPR(pullRequestState)) return null

  if (userRole && userRole !== 'author') {
    return (
      <ForYouItem
        itemId="closed"
        visual={{kind: 'icon', icon: GitPullRequestClosedIcon, tone: 'danger', glyphSize: 12}}
        title="Closed"
        subText="Nothing to do."
      />
    )
  }

  const canRestoreHeadRef = Boolean(mergeabilityData?.mergeBoxPullRequest.viewerCanRestoreHeadRef)
  const canReopenPullRequest = Boolean(user?.canReopen && !canRestoreHeadRef)
  const canDeleteHeadBranch = shouldShowDeleteHeadBranch(mergeabilityData)

  return (
    <>
      {canDeleteHeadBranch && <DeleteHeadBranch canReopen={canReopenPullRequest} />}
      {canRestoreHeadRef ? (
        <RestoreHeadBranch />
      ) : !canDeleteHeadBranch ? (
        <ReopenPullRequest canReopen={canReopenPullRequest} />
      ) : null}
    </>
  )
}
